export const languageTTLSeconds = 365 * 24 * 60 * 60
